<template>
  <div>
    <van-dialog
        v-model="visible"
        title="验证手机号"
        :beforeClose="verifyAccount"
        confirm-button-text="确定"
        :overlay-style="{zIndex:'1000'}"
        style="z-index: 1000"
    >

      <div class="padding-top">
        <van-field
            :border="false"
            class="mobileField"
            label="手机号"
            placeholder="请输入手机号"
            label-width="50px"
        >
          <template slot="input">
            <CommonTelInput :style-classes="{tel:true}" v-model="phoneNumber" :key="phoneNumber.regionCode"
                            :custom-style="{width: '100%',border:'1px solid lightgrey',fontSize:'14px',height:'24px',lineHeight:'24px',padding:'0'}"

                            @validChange="onValidChange"></CommonTelInput>
          </template>
        </van-field>
        <van-field
            v-model="verifyCode"
            center
            clearable
            label="验证码"
            placeholder="短信验证码"
            label-width="50px"
            :border="false"
        >
          <template slot="button">
            <van-button size="small" :loading="isBtnLoading" :disabled="isBtnDisabled" type="primary" @click="sendVerifyCode">
                <span v-if="!isBtnDisabled">
                  发送验证码
                </span>
              <span v-else>
                  {{resetCountDown}}秒后可重试
                </span>
            </van-button>
          </template>
        </van-field>
        <div style="font-size: 14px;padding: 10px 16px">今日剩余可验证次数：{{5-verifiedCount}}</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import {Dialog,  Toast, Field, Button} from 'vant';
import CommonTelInput from "@/components/common/tel-input/CommonTelInput";
import {getPhoneNumber, getVerifiedCount, sendVerifyCode, verify} from "@/api/duopei-account";

Vue.use(Dialog)
    .use(Toast)
    .use(Field)
    .use(Button)
export default {
  name: 'firstVerify',
  data() {
    return {
      index:'z-index',
      visible: true,
      phoneNumber: {
        regionCode:null,
        mobileDial:null,
        isValid:false,
        mobile: null,
      },
      verifyCode: null,
      resetCountDown: 0,
      resetCountDownTimer: null,
      isBtnDisabled: false,
      isBtnLoading: false,
      status: null,
      verifiedCount: 0
    };
  },
  components: {
    CommonTelInput
  },
  methods: {
    onValidChange(isValid){
      this.phoneNumber.isValid = isValid;
    },
    verifyAccount(action, done) {
      let vm = this;
      if (!this.phoneNumber.isValid) {
        done(false)
        Toast("请输入正确的手机号")
        return
      }
      if (action == 'confirm') {
        if(!this.verifyCode){
          done(false)
          Toast("请输入验证码")
          return;
        }
        verify(
            {
              phoneNumber: this.phoneNumber,
              verifyCode: this.verifyCode
            }
        ).then((res) => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            done()
            this.$store.state.isRequireVerify = false
            Toast.success('验证成功')
            vm.$router.replace('/')
          } else {
            done(false)
            Toast(data.msg)
          }
        })
      } else {
        done()
      }
    },
    /**
     * 发送验证码
     */
    sendVerifyCode() {
      if (!this.phoneNumber.isValid) {
        Toast("请输入正确的手机号")
        return
      }
      this.isBtnLoading = true;
      sendVerifyCode(this.phoneNumber).then(res => {
        const data = res.data
        this.isBtnLoading = false;
        if (data.code == 0) {
          this.verifiedCount++;
          this.resetCountDown=60;
          this.isBtnDisabled = true;
          window.clearInterval(this.resetCountDownTimer)
          this.resetCountDownTimer = setInterval(()=>{
            this.resetCountDown--;
            if(this.resetCountDown<=0){
              this.isBtnDisabled = false;
              window.clearInterval(this.resetCountDownTimer)
            }
          },1000)
          Toast('已发送')
        } else {
          Dialog.alert({
            title: '发送验证码失败',
            message: data.msg
          })
          this.isBtnDisabled = false;
        }
      })
    },
  },
  mounted() {
    Toast.loading({
      mask: true,
      message: '加载中...'
    });
    Promise.all([getPhoneNumber(),getVerifiedCount()]).then(results=>{
      Toast.clear()
      let res = results[0]
      if(res.data.code === 0){
        if(res.data.data){
          this.phoneNumber = res.data.data
        }
      }else{
        Dialog.alert({
          title: '加载失败',
          message: res.data.msg
        })
      }

      let res1 = results[1]
      if(res1.data.code === 0){
        this.verifiedCount = res1.data.data
      }else{
        Dialog.alert({
          title: '加载失败',
          message: res1.data.msg
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
/deep/.van-cell__title{
  flex: none;
}

</style>
